import React from "react";

var bgimg1 = require("../../images/background/image3.jfif");
var bgimg2 = "https://www.terreoceane.com/wp-content/uploads/2020/01/helia-3.jpg"
var bgimg3 = require("./../../images/background/bg-map.png");

class ContactUs1 extends React.Component {
  render() {
    return (
      <>
        <div
          className="section-full p-t80 p-b50 mobile-page-padding bg-center bg-cover bg-no-repeat bg-fixed"
          style={{ backgroundImage: "url(" + bgimg1 + ")" }}
        >
          <div className="overlay-main bg-black opacity-06" />
          <div className="section-content">
            <div className="container">
              {/* TITLE START */}
              {/* <div className="section-head">
                <div className="sx-separator-outer separator-left">
                  <div
                    className="sx-separator bg-white"
                    // style={{ backgroundImage: "url(" + bgimg2 + ")" }}
                  >
                    <h3 className="bg-white sep-line-one">Objectifs</h3>
                  </div>
                </div>
              </div> */}
              {/* TITLE END */}
              <div className="row">
                <div className="col-xl-6 col-lg-6 col-md-12">
                  <div className="about-home-3 m-b30">
                    <h3 className="m-t0 m-b20 sx-tilte text-white">
                      Objectifs de l’Association la vallée :
                    </h3>
                    <p className="text-white">
                      Veiller à répondre aux besoins de ses adhérents et à agir
                      pour une société meilleure afin de développer le « vivre
                      ensemble » et œuvrer pour l’intérêt général
                    </p>
                    <ul className="list-angle-right anchor-line text-white">
                      <li className="text-white">
                        Organiser des activités pédagogiques, culturelles,
                        sportives et de loisirs au profit des adhérents et des
                        membres de leur famille
                      </li>
                      <li>
                        Réaliser des programmes sociaux comprenant notamment des
                        projets d’habitat au profit de ses adhérents ;
                      </li>
                      <li>
                        Organiser des actions de bienfaisance et d’aide en
                        faveur des personnes démunies ;
                      </li>
                      <li>
                        Créer des relations de coopération et de partenariat
                        avec d’autres associations et organisations similaires
                      </li>
                    </ul>
                    {/* <div className="text-left">
                      <NavLink to="/about" className="site-button btn-half">
                        <span>Read More</span>
                      </NavLink>
                    </div> */}
                  </div>
                </div>
                <div className="col-xl-6 col-lg-6 col-md-12">
                  <div className="m-l40 video-section-full-v2">
                    <div
                      className="video-section-full bg-no-repeat bg-cover bg-center m-b30"
                      style={{ backgroundImage: "url(" + bgimg2 + ")" }}
                    >
                      <div className="overlay-main" />
                      <div className="video-section-inner">
                        <div className="video-section-content"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default ContactUs1;
